/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import IcomoonReact from 'icomoon-react';
import {
  animated,
  useSpring,
  useTransition,
  easings,
} from 'react-spring';
import { TransitionGlobal } from '../../../shared/GlobalStyles';
import iconSet from '../../../shared/images/teambuildr-selection.json';
import Text from '../../../shared/components/Text/Text';
import Spinner from '../../../shared/components/Spinner/Spinner';
import {
  fetchDocuments, fetchFolder, fetchDocument, addAsset,
} from '../ducks/calendarActions';
import { showErrorToast } from '../../../shared/utils/toastManager';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 500px;
  border-radius: 8px;
  padding: 24px;
  gap: 16px;
`;

const AnimationWrapper = styled('div')`
  display: flex;
  min-height: 311px;
  max-height: 315px;
  border:  2px solid #EEEEEE;
  border-radius: 4px;
`;
const AssetsContainer = styled(animated.div)`
  display: flex;
  min-height: 311px;
  max-height: 311px;
  width: 100%;
  border-radius: 4px;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  ${(props) => props.searchedDocuments && !props.searchedDocuments?.length && 'justify-content: center'};
`;

const FolderButtonWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }

`;

const AssetWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const CheckBoxAndAssetNameContainer = styled('div')`
  display: flex;
  gap: 8px;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid #E0E0E0;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
  
`;

const HeaderNavAndSearchBarContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LoadingContainer = styled('div')`
  display: flex;
  max-height: 400px;
  min-height: 311px;
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  background-color: #FCFCFC;
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SaveButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: ${(props) => props.backgroundColor};
  color: white;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 1px solid ${(props) => props.backgroundColor};
   ${(props) => !props.disabled && 'cursor: pointer;'}
  transition: ${TransitionGlobal};
  ${(props) => !props.disabled && ':hover { opacity: 0.7; }'}
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: #444444;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 2px solid #444444;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover { 
    opacity: 0.7; 
  }
`;

const SearchAndIcon = styled('div')`
  display: flex;
  align-items: center;
  border: 2px solid #EEEEEE;
  border-radius: 4px;
  background: white;
  overflow: hidden;
  width: 100%;
  min-height: 32px;
`;

const SearchIconContainer = styled('div')`
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
  height: 40px;
`;

const SearchContainer = styled('input')`
  display: flex;
  border: none;
  background: none;
  padding-left: 5px;
  width: 100%;
  height: 40x;

  ::placeholder {
  font-size: 16px;
  font-family: 'Nunito Sans';
  color: #9E9E9E;
}
`;

const TitleWrapper = styled('div')`
  display: flex;
  gap: 8px;
`;

const TextWrapper = styled('div')`
 display: flex;
 ${(props) => !props.disabled && 'cursor: pointer'};
  transition: ${TransitionGlobal};
  ${(props) => !props.disabled && ':hover { opacity: 0.7 }'};
`;

const AddAssetModalContent = ({ closeModal }) => {
  const dispatch = useDispatch();
  const resizeTimer = useRef(null);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [showSecondLayer, setShowSecondLayer] = useState(false);
  const [currentFolder, setCurrentFolder] = useState('All Folder');
  const [currentSelectedFolderInMainDirectory, setCurrentSelectedFolderInMainDirectory] = useState(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [isResizing, setIsResizing] = useState(false);
  const [checkedValue, setCheckedValue] = useState(null);
  const isDocumentsLoading = useSelector((state) => state.calendar.ui.isDocumentsLoading);
  const isFolderLoading = useSelector((state) => state.calendar.ui.isFolderLoading);
  const documentsArray = useSelector((state) => state.calendar.data.documents);
  const folderArray = useSelector((state) => state.calendar.data.folderDocuments);
  const sortedDocumentsArray = documentsArray.sort((a, b) => {
    if (a.type === 0 && b.type !== 0) {
      return -1;
    }
    if (a.type !== 0 && b.type === 0) {
      return 1;
    }
    return 0; /** Keep other elements in their current order if neither is a folder */
  });
  const searchedDocuments = sortedDocumentsArray?.filter((obj) => obj.name?.toLowerCase().includes(searchTerm.toLowerCase()));
  const searchedFolderDocuments = folderArray?.filter((obj) => obj.name?.toLowerCase().includes(searchTerm.toLowerCase()));

  useEffect(() => {
    dispatch(fetchDocuments(accountCode, {
      onSuccess: () => {
      },
      onError: () => {
        showErrorToast('Opps! Something went wrong. Error fetching documents.');
      },
    }));
  }, [currentUser]);

  useEffect(() => {
    if (accountCode !== undefined && currentSelectedFolderInMainDirectory) {
      const folderId = currentFolder.id;
      dispatch(fetchFolder(({ accountCode, folderId })));
    }
  }, [currentSelectedFolderInMainDirectory]);

  /** Track resize events using window.onresize */
  useEffect(() => {
    /** Handler function to manage resizing state */
    const handleResize = () => {
      setIsResizing(true);
      clearTimeout(resizeTimer.current);

      /** Set resizing state back to false after resize ends */
      resizeTimer.current = setTimeout(() => {
        setIsResizing(false);
      }, 200); /** Adjust timeout duration as needed */
    };

    /** Assign the handler to window.onresize */
    window.onresize = handleResize;

    /** Clean up by removing the handler */
    return () => {
      window.onresize = null;
    };
  }, []);

  const handleAddAsset = () => {
    dispatch(addAsset(checkedValue));
    closeModal();
  };

  const slideAnimation = useSpring({
    /** add the padding from the surrounding sidebar to make sure it moves totatally out of view */
    marginLeft: showSecondLayer ? `-${containerWidth + 16}` : '0px',
    width: '100%',
    height: '100%',
    maxWidth: '452px',
    minWidth: '250px',
    display: 'flex',
    background: 'white',
    config: {
      duration: 250,
      easing: easings?.easeInOutQuad,
    },
    immediate: isResizing, /** Prevent animation when activeItem is false */
  });

  const secondLayerTransitions = useTransition(!!showSecondLayer, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 1 },
    config: (state) => (state === 'leave' ? { duration: 0 } : { duration: 250 }),
  });

  return (

    <Wrapper>
      <Text fontSize='24px' fontWeight={700}>Add Document/Link</Text>
      <HeaderNavAndSearchBarContainer>
        <TitleWrapper>
          <TextWrapper>
            <Text
              color={currentFolder === 'All Folders' ? '#9E9E9E' : '#444444'}
              fontSize='16px'
              fontWeight={currentFolder === 'All Folders' ? 400 : 700}
              onClick={() => {
                setShowSecondLayer(false);
                setCurrentFolder('All Folders');
              }}
            >
              All Folders
            </Text>
          </TextWrapper>
          {showSecondLayer && currentFolder !== 'All Folders' && (
            <>
              <TextWrapper disabled>
                <Text
                  color='#9E9E9E'
                  fontSize='16px'
                >
                  /
                </Text>
              </TextWrapper>
              <TextWrapper disabled>
                <Text
                  color='#9E9E9E'
                  fontSize='16px'
                >
                  {currentFolder?.name}
                </Text>
              </TextWrapper>
            </>
          )}
        </TitleWrapper>
        <SearchAndIcon id='search-container' onClick={() => setIsSearchFocused(true)} isFocused={isSearchFocused}>
          <SearchIconContainer id='search-icon-container'>
            <IcomoonReact
              iconSet={iconSet}
              size={18}
              icon='magnifying-glass-alt'
              color='#9E9E9E'
            />
          </SearchIconContainer>
          <SearchContainer
            disabled={isDocumentsLoading || isFolderLoading}
            placeholder='Search'
            id='search-container-input'
            value={searchTerm}
            onFocus={() => setIsSearchFocused(true)}
            onChange={(inputValue) => {
              setSearchTerm(inputValue.target.value);
            }}
          />
        </SearchAndIcon>
      </HeaderNavAndSearchBarContainer>
      {isDocumentsLoading || isFolderLoading ? (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      ) : (
        <AnimationWrapper>
          <ResizeObserver
            onResize={(rect) => {
              setContainerWidth(rect?.width);
            }}
          />
          <AssetsContainer searchedDocuments={searchedDocuments} style={{ ...slideAnimation, overflow: !showSecondLayer ? 'auto' : 'hidden' }}>
            {sortedDocumentsArray?.length ? (
              <>
                {!searchedDocuments?.length ? (
                  <Text style={{ textAlign: 'center' }} color='#9E9E9E' fontSize='16px'>
                    No search results found
                  </Text>
                ) : (
                  searchedDocuments.map((document, index) => {
                    /** Initialize flags for titles */
                    let isUncategorizedTitle = false;

                    /** Check if current document is the first folder or uncategorized document */
                    if (
                      index > 0
                      && document.type !== 0
                      && searchedDocuments[index - 1].type === 0
                    ) {
                      isUncategorizedTitle = true;
                    }

                    return (
                      <>
                        {document.type === 0 ? (
                          <FolderButtonWrapper
                            onClick={() => {
                              setShowSecondLayer(true);
                              setCurrentFolder(document);
                              setCurrentSelectedFolderInMainDirectory(document);
                            }}
                          >
                            <Text
                              style={{
                                maxWidth: `${containerWidth - 100}px`,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                              }}
                              fontSize='16px'
                            >
                              {document?.name}
                            </Text>
                            <IcomoonReact
                              iconSet={iconSet}
                              size={12}
                              icon='altrightarrow'
                              color='#9E9E9E'
                            />
                          </FolderButtonWrapper>
                        ) : (
                          <>
                            {isUncategorizedTitle && <Text color='#9E9E9E' fontSize='16px' fontWeight={700}>Uncategorized</Text>}
                            <AssetWrapper
                              style={{ marginLeft: '5px' }}
                              onClick={() => {
                                const docId = document?.id;
                                if (document.type === 1) {
                                  dispatch(
                                    fetchDocument({ accountCode, docId }, {
                                      onSuccess: (response) => {
                                        window.open(response?.url, '_blank');
                                      },
                                      onError: () => {
                                        showErrorToast('Opps! Something went wrong. Unable to fetch document.');
                                      },
                                    }),
                                  );
                                }
                                if (document.type === 2) {
                                  window.open(document?.url, '_blank');
                                }
                              }}
                            >
                              <CheckBoxAndAssetNameContainer>
                                <input
                                  className='checkbox-input'
                                  type='checkbox'
                                  name={document.name}
                                  onClick={(e) => e.stopPropagation()}
                                  checked={checkedValue === document}
                                  onChange={() => {
                                    if (checkedValue === document) {
                                      setCheckedValue(null);
                                    } else {
                                      setCheckedValue(document);
                                    }
                                  }}
                                />
                                <Text
                                  style={{
                                    maxWidth: `${containerWidth - 100}px`,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {document?.name}
                                </Text>
                              </CheckBoxAndAssetNameContainer>
                              <IcomoonReact
                                iconSet={iconSet}
                                size={16}
                                icon='visible'
                                color='#9E9E9E'
                              />
                            </AssetWrapper>
                          </>
                        )}
                      </>
                    );
                  })
                )}
              </>
            ) : (
              <Text style={{ textAlign: 'center' }} color='#9E9E9E' fontSize='16px'>
                No Documents or Links Available
              </Text>
            )}
          </AssetsContainer>
          {secondLayerTransitions.map(({ item }) => (
            item && (
            <AssetsContainer
              searchedDocuments={searchedDocuments}
              style={{ marginLeft: '20px', overflow: showSecondLayer ? 'auto' : 'hidden' }}
            >
              {folderArray?.length ? (
                <>
                  {!searchedFolderDocuments?.length ? (
                    <Text style={{ textAlign: 'center ' }} color='#9E9E9E' fontSize='16px'>No search results found</Text>
                  ) : (
                    searchedFolderDocuments.map((document) => (
                      <AssetWrapper onClick={() => {
                        const docId = document?.id;
                        if (document.type === 1) {
                          dispatch(fetchDocument(({ accountCode, docId }), {
                            onSuccess: (response) => {
                              window.open(response?.url, '_blank');
                            },
                            onError: () => {
                              showErrorToast('Opps! Something went wrong. Unable to fetch document.');
                            },
                          }));
                        }
                        if (document.type === 2) {
                          window.open(document?.url, '_blank');
                        }
                      }}
                      >
                        <CheckBoxAndAssetNameContainer>
                          <input
                            className='checkbox-input'
                            type='checkbox'
                            name={document.name}
                            onClick={(e) => e.stopPropagation()}
                            checked={checkedValue === document}
                            onChange={() => {
                              if (checkedValue === document) {
                                setCheckedValue(null);
                              } else {
                                setCheckedValue(document);
                              }
                            }}
                          />
                          <Text style={{
                            maxWidth: `${containerWidth - 100}px`,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                          }}
                          >
                            {document?.name}
                          </Text>
                        </CheckBoxAndAssetNameContainer>
                        <IcomoonReact
                          iconSet={iconSet}
                          size={16}
                          icon='visible'
                          color='#9E9E9E'
                        />
                      </AssetWrapper>
                    ))
                  )}
                </>
              ) : (
                <Text style={{ textAlign: 'center ' }} color='#9E9E9E' fontSize='16px'>No Documents or Links Available</Text>
              )}
            </AssetsContainer>
            )))}
        </AnimationWrapper>
      )}
      <ButtonsContainer>
        <SaveButton onClick={() => (!isDocumentsLoading && !isFolderLoading && checkedValue && handleAddAsset())} backgroundColor={(isDocumentsLoading || isFolderLoading || !checkedValue) ? '#BDBDBD' : '#444444'} disabled={isDocumentsLoading || isFolderLoading || !checkedValue}>
          <Text color='white' fontSize='16px' fontWeight={700}>ADD</Text>
        </SaveButton>
        <CancelButton onClick={() => closeModal()}>
          <Text fontSize='16px' fontWeight={700}>CANCEL</Text>
        </CancelButton>
      </ButtonsContainer>
    </Wrapper>

  );
};

export default AddAssetModalContent;
